import type { MenuItemTypes } from "../components/custom/constants/menu";

export const attachOnlineOrdersBadge = (
  menuItems: MenuItemTypes[],
  unreadCount: number,
): MenuItemTypes[] => {
  return menuItems.map((item) => {
    const nextItem: MenuItemTypes = {
      ...item,
    };

    if (item.key === "onlineOrders") {
      if (unreadCount > 0) {
        nextItem.badge = {
          variant: "danger",
          text: String(unreadCount),
        };
      } else {
        delete nextItem.badge;
      }
    }

    if (item.children?.length) {
      nextItem.children = attachOnlineOrdersBadge(item.children, unreadCount);
    }

    return nextItem;
  });
};

export default attachOnlineOrdersBadge;
